import React, { Component } from "react";
import WithConsumer from '../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxSiteLoaded 	= () => context.siteLoaded;
	const siteLoaded 		= ctxSiteLoaded();
	
	let coverClass = 'c-cover';
	
	if (siteLoaded === true) {
		coverClass = 'c-cover state-loaded';
	}
	
	return (
		<div className={coverClass}></div>
	)
	
}
export default WithConsumer(Cover);